// extracted by mini-css-extract-plugin
module.exports = {"card":"PiechartWidget_card__2o6xP","chartArea":"PiechartWidget_chartArea__1hLEs"};